import asyncActionTypes from '../actions/types.js';

const initialState = {
  disconnectAttempts: 1,
  ModalDisconnection:false,
};

const BaggageRedemption = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.BAGGAGEREDEMPTION_DISCONNECT_ATTEMPTS:
      return {
        ...state,
        disconnectAttempts: action.payload,
      };
    case asyncActionTypes.BAGGAGEREDEMPTION_DISCONNECT_MODAL:
      return {
        ...state,
        ModalDisconnection: action.payload,
      };
    default:
      return state;
  }
};

export default BaggageRedemption;
